import { all } from 'typed-redux-saga'
import {
	bankSaga,
	gosbSaga,
	sectorSaga,
	channelSaga,
	specialOfferSaga,
	channelStructureSaga,
	citiesSaga,
	regionsSaga,
} from 'Pages/referenceBooks'

export function* referenceBooksSaga() {
	yield* all([
		bankSaga(),
		gosbSaga(),
		sectorSaga(),
		channelSaga(),
		specialOfferSaga(),
		channelStructureSaga(),
		citiesSaga(),
		regionsSaga(),
	])
}
